import { notify, Notify } from './notificationStore';

export { notify } from './notificationStore';
export type { Notify, NotifyOptions, NotifySeverity, NotifyAction } from './notificationStore';
export { default as NotificationHost } from './NotificationHost';

/** Для компонентов: const notify = useNotify(); - тот же глобальный notify, ссылка стабильна между рендерами */
export const useNotify = (): Notify => notify;
